<template>
  <main>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: './visa_list', query: { id: info[0].visa_product.CountryID, detailId: info[0].ProductID } }">签证详情</el-breadcrumb-item>
      <el-breadcrumb-item>提交订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-steps :active="2" simple>
      <el-step title="提交订单" icon="el-icon-edit"></el-step>
      <el-step title="在线支付" icon="el-icon-connection"></el-step>
      <!-- <el-step title="上传资料" icon="el-icon-picture"></el-step> -->
      <el-step title="完成" icon="el-icon-chat-line-round"></el-step>
    </el-steps>
    <section class="order_info">
      <figure class="desc">
        <i class="icon-gou"></i>
        <p>
          <span>订单提交成功，请您尽快付款！ 订单号：<b>{{ info[0].OrderNO }}</b></span>
          <span>请在<strong>2小时内</strong>完成订单支付， 否则订单会自动取消。</span>
        </p>
      </figure>
      <div class="price">
        <p><span>应付金额：</span><b>{{ Number(info[0].total_amount) - Number(info[0].receipt_amount) }}</b></p>
        <strong :class="{ open: showTable }" @click="showTable = !showTable">订单详情</strong>
      </div>
      <el-table :data="info" v-show="showTable">
        <el-table-column prop="ProductName" label="产品名称"></el-table-column>
        <el-table-column align="center" prop="UserDateTime" label="出行日期"></el-table-column>
        <el-table-column align="center" prop="visaAmount" label="订单价格"></el-table-column>
        <el-table-column align="center" prop="visa_order_ins.TotalAmount" label="保险费用"></el-table-column>
        <el-table-column align="center" prop="coupon_deduct_amount" label="优惠券抵扣"></el-table-column>
        <el-table-column align="center" prop="express_data_amount" label="资料邮寄"></el-table-column>
        <el-table-column align="center" prop="post_back_amount" label="资料回邮"></el-table-column>
      </el-table>
    </section>
    <section class="pay">
      <h3>支付方式</h3>
      <label>
        <el-radio v-model="payType" :disabled="true" label="0">余额支付</el-radio>
        <el-radio v-model="payType" label="1">第三方支付</el-radio>
      </label>
      <ul class="user" v-show="payType === '0'">
        <li>
          <span>账户余额：</span><b>0.00元</b>
          <strong>余额不足，请先<router-link :to="{ path: './' }">充值</router-link></strong>
        </li>
        <li>
          <span>支付密码：</span>
          <el-input disabled="" type="password" size="small" v-model="test"></el-input>
          <strong>请先设置支付密码，<router-link :to="{ path: './' }">点击设置</router-link>跳至设置支付密码页面</strong>
        </li>
      </ul>
      <nav v-show="payType === '1'" class="otherPay">
        <a 
          :class="{ on: payOption === 'zfb' }"
          @click="updatePayType"><img src="@assets/img/zhifubao.png" alt=""></a>
        <a 
          :class="{ on: payOption === 'wx' }"
          @click="payOption = 'wx'"><img src="@assets/img/weixinzhifu.png" alt=""></a>
      </nav>
      <div class="qrcode" v-loading="loading" :class="{ pay_success: payState }">
        <vue-qrcode :value="`${ payOption === 'wx' ? 'https://h5.cstravel.cn/api/v2/Yspay/wxJs?order_type=visa&order_sn='+info[0].OrderNO : alipayUrl }`" :options="{ width: 200 }"/>
        <p>手机扫码进行支付</p>
      </div>
    </section>
  </main>
</template>

<script>
import $visa from '@api/visa';
import VueQrcode from 'vue-qrcode'
export default {
  components: {
    VueQrcode
  },
  data () {
    return {
      info: [{}],
      showTable: false,
      payType: '1',
      payOption: 'wx',
      alipayUrl: null,
      payState: false,
      loading: false, // 支付方式loading

      test: ''
    }
  },
  created () {
    const { orderNo } = this.$route.query;
    if ( !orderNo ) {
      this.$router.push('visa');
      return;
    }
    this.getDetail(orderNo);
    this.listenPayResult(orderNo);
  },
  methods: {
    updatePayType () {
      const { payOption, info } = this;
      const { orderNo } = this.$route.query;
      if ( payOption !== 'zfb' ) {
        this.loading = true;
        this.payOption = 'zfb';
        $visa.payInfo(orderNo).then(res => {
          this.alipayUrl = res.source_qr_code_url;
          this.loading = false;
        })
      }
    },
    getDetail (orderNo) {
      $visa.detail(orderNo).then(res => this.info = [res]);
    },
    listenPayResult (orderNo) {
      if ( this.$route.name !== 'order_pay' ) { return; }
      $visa.payResult(orderNo).then(({ isPaid }) => {
        switch (isPaid) {
          case 0: {
            setTimeout(() => {
              this.listenPayResult(orderNo);
            }, 2000);
            break;
          }
          case 1: {
            this.$message.success('支付成功！');
            this.payState = true;
            setTimeout(() => {
              this.$router.push({ name: 'order_list' });
            }, 3000);
            break;
          }
        }
      })
    }
  }
}
</script>

<style scoped src="./pay.css"> </style>